import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class InvoicesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/invoices", { params: toSnakeCase(params) });
  }

  fetchSummary() {
    return securedAxiosInstance.get("/invoices/summary");
  }

  markAsPaid(invoiceIds) {
    return securedAxiosInstance.put("/invoices/paid", toSnakeCase({ invoiceIds }));
  }

  sendReport(params) {
    return securedAxiosInstance.get("/invoices/reporting", { params: toSnakeCase(params) });
  }

  downloadQontoBulkTransferCSV(params) {
    return securedAxiosInstance.post("/invoices/qonto_bulk_transfer.csv", toSnakeCase(params));
  }
}

export default new InvoicesService();
